export function initialCountForProduct(cartProduct?: { count: number }[]) {
  return (
    (cartProduct && cartProduct.reduce((prev, curr) => prev + curr.count, 0)) ||
    0
  );
}
